import { SVGProps, Ref, forwardRef } from 'react';

export const ClockRewindOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M22.195 12c0 2.142-.537 4.187-1.782 5.68-1.22 1.465-3.22 2.52-6.413 2.52-2.077 0-3.65-.445-4.83-1.16l-1.304 1.303a8.8 8.8 0 0 0 2.03 1.016v.002c1.174.413 2.536.64 4.1.64 3.63 0 6.181-1.22 7.805-3.169C23.4 16.914 24 14.41 24 12s-.6-4.914-2.2-6.832C20.179 3.22 17.63 2 14 2c-3.632 0-6.182 1.22-7.806 3.168C4.596 7.087 3.995 9.592 3.995 12v3.323L1.273 12.6 0 13.874l4.895 4.894 4.895-4.894L8.517 12.6l-2.722 2.722V12H5.8c0-2.141.537-4.186 1.782-5.68 1.22-1.464 3.22-2.52 6.413-2.52 3.196 0 5.197 1.055 6.418 2.52 1.245 1.494 1.782 3.54 1.782 5.68"
                fill="currentColor"
            />
            <path d="M13.1 6v6.51l5.437 3.262.926-1.544-4.563-2.737V6z" fill="currentColor" />
        </g>
    </svg>
));
ClockRewindOutlinedSize24Glyph.displayName = 'ClockRewindOutlinedSize24Glyph';
